// extracted by mini-css-extract-plugin
export default {"header-container":"Reseller_header-container__o7Ole","flex":"Reseller_flex__EjBXI"};